// import React, { useState } from "react";
// import "./Chatbot.css"; // Optional external CSS

// const Chatbot = () => {
//     const [step, setStep] = useState(1);
//     const [inquiryType, setInquiryType] = useState("");
//     const [region, setRegion] = useState("");
//     const [email, setEmail] = useState("");
//     const [phone, setPhone] = useState("");
//     const [error, setError] = useState(false);
//     const [thankYouMessage, setThankYouMessage] = useState("");

//     const handleNext = () => {
//         if (step === 1 && !inquiryType) return;
//         if (step === 2 && !region) return;
//         setStep(step + 1);
//     };

//     const validateAndSubmit = () => {
//         const emailPattern = /^[^ ]+@[^ ]+\.[a-z]{2,3}$/;
//         if (!email.match(emailPattern)) {
//             setError(true);
//             return;
//         }

//         setError(false);

//         let message = `<p>Thank you for contacting us.`;

//         if (inquiryType === "Seeking a job") {
//             message += ` Please email your resume to <b>hr@premierpumps.net</b>.</p>`;
//         } else if (inquiryType === "Others") {
//             message += ` PREMIER will contact you soon. For urgent queries, reach us at <b>avinash@premierpumps.net</b>.</p>`;
//         } else {
//             message += ` PREMIER will contact you soon. You can also reach us at <b>support@premierpumps.net</b>.</p>`;
//         }

//         setThankYouMessage(message);
//         setStep(4);
//     };

//     return (
//         <div className="chatbox" style={styles.chatbox}>
//             {step === 1 && (
//                 <div className="chat">
//                     <p>
//                         Hello!! Welcome to <b>PREMIER PUMPS</b><br />How can we help you?
//                     </p>
//                     <select value={inquiryType} onChange={(e) => setInquiryType(e.target.value)} style={styles.select}>
//                         <option disabled value="">Select an option</option>
//                         <option>Purchase a Pump/Spare</option>
//                         <option>Get my Pump serviced</option>
//                         <option>Become a Sales Partner</option>
//                         <option>Seeking a job</option>
//                         <option>Others</option>
//                     </select>
//                     <button onClick={handleNext} style={styles.button}>Next</button>
//                 </div>
//             )}

//             {step === 2 && (
//                 <div className="chat">
//                     <p>Which region are you from?</p>
//                     <select value={region} onChange={(e) => setRegion(e.target.value)} style={styles.select}>
//                         <option disabled value="">Select your region</option>
//                         <option>INDIA</option>
//                         <option>USA</option>
//                         <option>OTHERS</option>
//                     </select>
//                     <button onClick={handleNext} style={styles.button}>Next</button>
//                 </div>
//             )}

//             {step === 3 && (
//                 <div className="chat">
//                     <p>Enter your email ID and phone number (optional):</p>
//                     <input
//                         type="email"
//                         placeholder="Email ID"
//                         value={email}
//                         onChange={(e) => setEmail(e.target.value)}
//                         required
//                         style={styles.input}
//                     />
//                     <input
//                         type="text"
//                         placeholder="Phone number (optional)"
//                         value={phone}
//                         onChange={(e) => setPhone(e.target.value)}
//                         style={styles.input}
//                     />
//                     <button onClick={validateAndSubmit} style={styles.button}>Submit</button>
//                     {error && <p style={{ color: "red" }}>Please enter a valid email address.</p>}
//                 </div>
//             )}

//             {step === 4 && (
//                 <div className="chat" dangerouslySetInnerHTML={{ __html: thankYouMessage }} />
//             )}
//         </div>
//     );
// };

// export default Chatbot;

// // Inline Styles (or you can move them to Chatbot.css)
// const styles = {
//     chatbox: {
//         maxWidth: "500px",
//         margin: "auto",
//         background: "white",
//         borderRadius: "10px",
//         padding: "20px",
//         boxShadow: "0 0 10px rgba(0,0,0,0.1)",
//     },
//     input: {
//         width: "100%",
//         margin: "10px 0",
//         padding: "10px",
//         borderRadius: "5px",
//         border: "1px solid #ccc",
//     },
//     select: {
//         width: "100%",
//         margin: "10px 0",
//         padding: "10px",
//         borderRadius: "5px",
//         border: "1px solid #ccc",
//     },
//     button: {
//         width: "100%",
//         padding: "10px",
//         background: "#0056b3",
//         color: "white",
//         border: "none",
//         borderRadius: "5px",
//         cursor: "pointer",
//         marginTop: "10px",
//     },
// };
// ///////////////

// import React, { useState } from "react";
// import "./Chatbot.css"; // Optional external CSS

// const Chatbot = () => {
//     const [messages, setMessages] = useState([
//         { from: "bot", text: "Hello!! Welcome to PREMIER PUMPS\nHow can we help you?" },
//     ]);
//     const [step, setStep] = useState(0);
//     const [context, setContext] = useState({});
//     const [userInput, setUserInput] = useState(""); // For steps requiring text input (e.g., email/phone)

//     // Predefined options for each step
//     const inquiryOptions = [
//         { value: "1", label: "I want to purchase a Pump/Spare" },
//         { value: "2", label: "I want to get my Pump serviced" },
//         { value: "3", label: "I want to be a Sales Partner" },
//         { value: "4", label: "I’m seeking a job" },
//         { value: "5", label: "Others" },
//     ];

//     const regionOptions = [
//         { value: "1", label: "INDIA" },
//         { value: "2", label: "USA" },
//         { value: "3", label: "OTHERS" },
//     ];

//     const handleOptionClick = (value, label) => {
//         const updatedMessages = [...messages, { from: "user", text: label }];

//         switch (step) {
//             case 0:
//                 setContext({ ...context, inquiryType: value });
//                 updatedMessages.push({
//                     from: "bot",
//                     text: "Which region are you from?\n1. INDIA\n2. USA\n3. OTHERS",
//                 });
//                 setStep(1);
//                 break;
//             case 1:
//                 setContext({ ...context, region: value });
//                 updatedMessages.push({ from: "bot", text: "Enter your phone no/email id" });
//                 setStep(2);
//                 break;
//             default:
//                 updatedMessages.push({ from: "bot", text: "Conversation complete. Click 'Restart' to begin again." });
//                 setStep(4);
//                 break;
//         }

//         setMessages(updatedMessages);
//     };

//     const handleTextSubmit = () => {
//         if (!userInput.trim()) return;
//         const updatedMessages = [...messages, { from: "user", text: userInput }];

//         if (step === 2) {
//             const emailMatch = userInput.match(/\S+@\S+\.\S+/);
//             if (!emailMatch) {
//                 updatedMessages.push({ from: "bot", text: "*Enter valid email id (error check)" });
//                 setMessages(updatedMessages);
//                 return;
//             }
//             const email = emailMatch[0];
//             const phone = userInput.replace(email, "").trim();
//             setContext({ ...context, email, phone });

//             if (context.inquiryType === "4" || context.inquiryType.toLowerCase().includes("job")) {
//                 updatedMessages.push({
//                     from: "bot",
//                     text: "Thank you for contacting us.\nPlease email your resume to hr@premierpumps.net",
//                 });
//             } else if (context.inquiryType === "5" || context.inquiryType.toLowerCase().includes("others")) {
//                 updatedMessages.push({ from: "bot", text: "*Input your message" });
//                 setStep(3);
//             } else {
//                 const emailID =
//                     context.region === "1" || context.region.toLowerCase() === "india"
//                         ? "support@premierpumps.net"
//                         : "avinash@premierpumps.net";
//                 updatedMessages.push({
//                     from: "bot",
//                     text: `Thank you for contacting us.\nPREMIER will contact you soon.\nIn the meanwhile, you can reach us at ${emailID}`,
//                 });
//                 setStep(4);
//             }
//         } else if (step === 3) {
//             updatedMessages.push({
//                 from: "bot",
//                 text: "Thank you for contacting us.\nPREMIER will contact you soon.\nIn the meanwhile, you can reach us at avinash@premierpumps.net",
//             });
//             setStep(4);
//         }

//         setMessages(updatedMessages);
//         setUserInput("");
//     };

//     const handleKeyDown = (e) => {
//         if (e.key === "Enter") handleTextSubmit();
//     };

//     const handleRestart = () => {
//         setMessages([
//             { from: "bot", text: "Hello!! Welcome to PREMIER PUMPS\nHow can we help you?" },
//         ]);
//         setStep(0);
//         setContext({});
//         setUserInput("");
//     };

//     return (
//         <div className="chatbox" style={styles.chatbox}>
//             <div style={{ height: 400, overflowY: "scroll", paddingBottom: 10 }}>
//                 {messages.map((msg, i) => (
//                     <div key={i} style={{ textAlign: msg.from === "bot" ? "left" : "right", margin: "10px 0" }}>
//                         <div
//                             style={{
//                                 display: "inline-block",
//                                 padding: 10,
//                                 borderRadius: 10,
//                                 background: msg.from === "bot" ? "#eee" : "#cce5ff",
//                                 whiteSpace: "pre-wrap",
//                             }}
//                         >
//                             {msg.text}
//                         </div>
//                     </div>
//                 ))}
//             </div>
//             <div style={{ marginTop: 10 }}>
//                 {step === 0 && (
//                     <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
//                         {inquiryOptions.map((option) => (
//                             <button
//                                 key={option.value}
//                                 onClick={() => handleOptionClick(option.value, option.label)}
//                                 style={styles.button}
//                             >
//                                 {option.label}
//                             </button>
//                         ))}
//                     </div>
//                 )}
//                 {step === 1 && (
//                     <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
//                         {regionOptions.map((option) => (
//                             <button
//                                 key={option.value}
//                                 onClick={() => handleOptionClick(option.value, option.label)}
//                                 style={styles.button}
//                             >
//                                 {option.label}
//                             </button>
//                         ))}
//                     </div>
//                 )}
//                 {(step === 2 || step === 3) && (
//                     <div style={{ display: "flex", gap: 10 }}>
//                         <input
//                             value={userInput}
//                             onChange={(e) => setUserInput(e.target.value)}
//                             onKeyDown={handleKeyDown}
//                             style={styles.input}
//                             placeholder={step === 2 ? "Enter phone no/email id" : "Type your message..."}
//                         />
//                         <button onClick={handleTextSubmit} style={styles.button}>
//                             Send
//                         </button>
//                     </div>
//                 )}
//                 {step === 4 && (
//                     <button onClick={handleRestart} style={styles.button}>
//                         Restart
//                     </button>
//                 )}
//             </div>
//         </div>
//     );
// };

// export default Chatbot;

// // Inline Styles (or you can move them to Chatbot.css)
// const styles = {
//     chatbox: {
//         maxWidth: "500px",
//         margin: "auto",
//         background: "white",
//         borderRadius: "10px",
//         padding: "20px",
//         boxShadow: "0 0 10px rgba(0,0,0,0.1)",
//     },
//     input: {
//         flex: 1,
//         margin: "10px 0",
//         padding: "10px",
//         borderRadius: "5px",
//         border: "1px solid #ccc",
//     },
//     button: {
//         padding: "10px 20px",
//         background: "#0056b3",
//         color: "white",
//         border: "none",
//         borderRadius: "25px",
//         cursor: "pointer",
//     },
// };
// ////////
import React, { useState, useRef, useEffect } from "react";
import "./Chatbot.css"; // Optional external CSS for additional styling

const Chatbot = () => {
    const [messages, setMessages] = useState([
        { from: "bot", text: "Hello!! Welcome to PREMIER PUMPS\nHow can we help you?" },
    ]);
    const [step, setStep] = useState(0);
    const [context, setContext] = useState({});
    const [userInput, setUserInput] = useState("");
    const [isVisible, setIsVisible] = useState(true);
    const [isMinimized, setIsMinimized] = useState(false);
    const [isSending, setIsSending] = useState(false);
    const [phoneError, setPhoneError] = useState("");
    const messagesRef = useRef(null);

    const inquiryOptions = [
        { value: "1", label: "I want to purchase a Pump/Spare" },
        { value: "2", label: "I want to get my Pump serviced" },
        { value: "3", label: "I want to be a Sales Partner" },
        { value: "4", label: "I'm seeking a job" },
        { value: "5", label: "Others" },
    ];

    const regionOptions = [
        { value: "INDIA", label: "INDIA" },
        { value: "USA", label: "USA" },
        { value: "OTHERS", label: "OTHERS" },
    ];

    useEffect(() => {
        if (messagesRef.current) {
            messagesRef.current.scrollTo({
                top: messagesRef.current.scrollHeight,
                behavior: "smooth",
            });
        }
    }, [messages]);

    const submitFormData = async (data) => {
        try {
            await fetch("https://peracause.com/chatbot-premier-pumps.php", {
                method: "POST",
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
                body: new URLSearchParams(data).toString(),
            });
            return true;
        } catch (error) {
            console.error("Error submitting form:", error);
            return false;
        }
    };

    const handleOptionClick = async (value, label) => {
        const updatedMessages = [...messages, { from: "user", text: label }];
        
        if (step === 0) {
            const inquiryLabel = inquiryOptions.find(opt => opt.value === value)?.label || value;
            const newContext = { ...context, inquiryType: inquiryLabel };
            setContext(newContext);
    
            if (value === "4") {
                updatedMessages.push({
                    from: "bot",
                    text: "Thank you for contacting us.\nPlease email your resume to hr@premierpumps.net",
                });
                setStep(6);
            } else {
                updatedMessages.push({ from: "bot", text: "Which region are you from?" });
                setStep(1);
            }
        } else if (step === 1) {
            const regionLabel = regionOptions.find(opt => opt.value === value)?.label || value;
            setContext({ ...context, region: regionLabel });
            updatedMessages.push({ from: "bot", text: "Please enter your email address" });
            setStep(2);
        } else if (step === 3) {
            updatedMessages.push({ from: "user", text: label });
            if (value === "yes") {
                updatedMessages.push({
                    from: "bot",
                    text: "Enter your country code followed by phone number",
                });
                setStep(4);
            } else {
                const formData = {
                    email: context.email,
                    phone: "",
                    region: context.region || "Not specified",
                    inquiryType: context.inquiryType || "General",
                    timestamp: new Date().toISOString()
                };

                await submitFormData(formData);

                updatedMessages.push({
                    from: "bot",
                    text: `Thank you for contacting us.\nPREMIER will contact you soon.\nIn the meanwhile, you can reach us at support@premierpumps.net`,
                });
                setStep(6);
            }
        }
        setMessages(updatedMessages);
    };

    const handleTextSubmit = async () => {
        if (!userInput.trim()) return;
        setIsSending(true);
    
        const updatedMessages = [...messages, { from: "user", text: userInput }];
    
        if (step === 2) {
            const emailMatch = userInput.match(/\S+@\S+\.\S+/);
            if (!emailMatch) {
                updatedMessages.push({ from: "bot", text: "*Enter a valid email address." });
                setMessages(updatedMessages);
                setIsSending(false);
                return;
            }
            const email = emailMatch[0];
            setContext({ ...context, email });
    
            updatedMessages.push({
                from: "bot",
                text: "For faster response, do you prefer to share your contact / phone number?",
            });
            setStep(3);
        } else if (step === 4) {
            const phonePattern = /^[+]?[0-9]{10,15}$/;
            if (!phonePattern.test(userInput)) {
                setPhoneError("Please enter a valid phone number (10-15 digits, optional country code).");
                setIsSending(false);
                return;
            }
            const phone = userInput.trim();
            setContext({ ...context, phone });
            setPhoneError("");
    
            const formData = {
                email: context.email,
                phone: phone,
                region: context.region || "Not specified",
                inquiryType: context.inquiryType || "General",
                timestamp: new Date().toISOString()
            };

            const success = await submitFormData(formData);

            if (!success) {
                updatedMessages.push({ from: "bot", text: "*Server error. Please try again later." });
            } else {
                updatedMessages.push({
                    from: "bot",
                    text: `Thank you for contacting us.\nPREMIER will contact you soon.\nIn the meanwhile, you can reach us at support@premierpumps.net`,
                });
            }
            setStep(6);
        }
    
        setMessages(updatedMessages);
        setUserInput("");
        setIsSending(false);
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") handleTextSubmit();
    };

    const handleRestart = () => {
        setMessages([{ from: "bot", text: "Hello!! Welcome to PREMIER PUMPS\nHow can we help you?" }]);
        setStep(0);
        setContext({});
        setUserInput("");
        setIsMinimized(false);
    };

    const handleClose = () => setIsVisible(false);
    const handleMinimize = () => setIsMinimized(!isMinimized);
    if (!isVisible) return null;

    return (
        <div className="chatbox" style={styles.chatbox}>
            <div className="chat-header" style={styles.chatHeader}>
                <span>How can we help you today</span>
                <div style={{ display: "flex", gap: "10px" }}>
                    <button onClick={handleRestart} style={styles.restartButton}>↻</button>
                    <button onClick={handleMinimize} style={styles.minimizeButton}>
                        {isMinimized ? "□" : "−"}
                    </button>
                    <button onClick={handleClose} style={styles.closeButton}>×</button>
                </div>
            </div>
            {!isMinimized && (
                <div style={styles.chatContent}>
                    <div className="chat-messages" style={styles.chatMessages} ref={messagesRef}>
                        {messages.map((msg, i) => (
                            <div key={i} style={{ textAlign: msg.from === "bot" ? "left" : "right", margin: "10px 0" }}>
                                <div
                                    style={{
                                        display: "inline-block",
                                        padding: "10px 15px",
                                        borderRadius: "20px",
                                        background: msg.from === "bot" ? "#e9ecef" : "#0056b3",
                                        color: msg.from === "bot" ? "#000" : "#fff",
                                        maxWidth: "70%",
                                        whiteSpace: "pre-wrap",
                                    }}
                                >
                                    {msg.text}
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="chat-input" style={styles.chatInput}>
                        {step === 0 && (
                            <div style={{ display: "flex", flexWrap: "wrap", gap: 10, justifyContent: "end" }}>
                                {inquiryOptions.map((option) => (
                                    <button
                                        key={option.value}
                                        onClick={() => handleOptionClick(option.value, option.label)}
                                        style={styles.optionButton}
                                    >
                                        {option.label}
                                    </button>
                                ))}
                            </div>
                        )}

                        {step === 1 && (
                            <div style={{ display: "flex", flexWrap: "wrap", gap: 10, justifyContent: "center" }}>
                                {regionOptions.map((option) => (
                                    <button
                                        key={option.value}
                                        onClick={() => handleOptionClick(option.value, option.label)}
                                        style={styles.optionButton}
                                    >
                                        {option.label}
                                    </button>
                                ))}
                            </div>
                        )}

                        {step === 2 || step === 4 ? (
                            <form
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    handleTextSubmit();
                                }}
                                style={{ display: "flex", gap: 10, width: "100%" }}
                            >
                                <input
                                    value={userInput}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        const sanitized =
                                            step === 4
                                                ? value.replace(/[^0-9()+]/g, "")
                                                : value;
                                        setUserInput(sanitized);
                                    }}
                                    onKeyDown={handleKeyDown}
                                    style={styles.input}
                                    placeholder={step === 2 ? "Enter your email" : "Enter your phone number"}
                                />
                                <button type="submit" style={styles.sendButton}>
                                    {isSending ? "Sending..." : "Send"}
                                </button>
                            </form>
                        ) : null}

                        {phoneError && (
                            <div style={styles.errorMessage}>{phoneError}</div>
                        )}

                        {step === 3 && (
                            <div style={{ display: "flex", gap: 10, justifyContent: "center" }}>
                                <button onClick={() => handleOptionClick("yes", "Yes")} style={styles.optionButton}>
                                    Yes
                                </button>
                                <button onClick={() => handleOptionClick("no", "No")} style={styles.optionButton}>
                                    No
                                </button>
                            </div>
                        )}

                        {step === 6 && (
                            <button onClick={handleRestart} style={styles.restartButtonFull}>
                                Restart
                            </button>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};




export default Chatbot;

// Inline Styles (unchanged)
const styles = {
    chatbox: {
        maxWidth: "400px",
        maxHeight: "600px",
        minHeight: "auto",
        margin: "20px auto",
        background: "#f8f9fa",
        borderRadius: "10px",
        boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
        fontFamily: "Arial, sans-serif",
        display: "flex",
        flexDirection: "column",
    },
    chatHeader: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "10px 15px",
        background: "#0056b3",
        color: "#fff",
        borderTopLeftRadius: "10px",
        borderTopRightRadius: "10px",
        fontSize: "16px",
        position: "sticky",
        top: 0,
        zIndex: 10,
    },
    chatContent: {
        display: "flex",
        flexDirection: "column",
        flex: 1,
        overflow: "hidden",
    },
    chatMessages: {
        flex: 1,
        padding: "20px",
        overflowY: "auto",
        background: "#e9ecef",
        minHeight: "0",
    },
    chatInput: {
        padding: "10px 20px",
        background: "#fff",
        borderBottomLeftRadius: "10px",
        borderBottomRightRadius: "10px",
        position: "sticky",
        bottom: 0,
        zIndex: 10,
    },
    restartButton: {
        background: "none",
        border: "none",
        color: "#fff",
        fontSize: "18px",
        cursor: "pointer",
        padding: "0",
    },
    minimizeButton: {
        background: "none",
        border: "none",
        color: "#fff",
        fontSize: "18px",
        cursor: "pointer",
        padding: "0",
    },
    closeButton: {
        background: "none",
        border: "none",
        color: "#fff",
        fontSize: "18px",
        cursor: "pointer",
        padding: "0",
    },
    optionButton: {
        padding: "10px 20px",
        background: "#0056b3",
        color: "#fff",
        border: "none",
        borderRadius: "20px",
        cursor: "pointer",
        fontSize: "14px",
        whiteSpace: "nowrap",
    },
    input: {
        flex: 1,
        padding: "10px",
        border: "1px solid #ced4da",
        borderRadius: "20px",
        outline: "none",
        fontSize: "14px",
    },
    sendButton: {
        padding: "10px 20px",
        background: "#0056b3",
        color: "#fff",
        border: "none",
        borderRadius: "20px",
        cursor: "pointer",
        fontSize: "14px",
    },
    restartButtonFull: {
        padding: "10px 20px",
        background: "#0056b3",
        color: "#fff",
        border: "none",
        borderRadius: "20px",
        cursor: "pointer",
        width: "100%",
        fontSize: "14px",
    },
};